import React from 'react';
import { cx } from './classNames';
import './ui.css';

export type CardPadding = 'none' | 'sm' | 'md' | 'lg';

/* title は ReactNode を受けたいので、string 固定の DOM 属性側を外す（Button と同じ扱い） */
export interface CardProps extends Omit<React.HTMLAttributes<HTMLElement>, 'title'> {
  /** ヘッダ左の題。title / subtitle / actions のどれかがあればヘッダ行が出る */
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  /** ヘッダ右のボタン群 */
  actions?: React.ReactNode;
  /** 本文の余白。テーブルを敷き詰めるときは none */
  padding?: CardPadding;
}

export function Card({ title, subtitle, actions, padding = 'md', className, children, ...rest }: CardProps) {
  const hasHeader = title != null || subtitle != null || actions != null;

  return (
    <section className={cx('ui-card', className)} {...rest}>
      {hasHeader && (
        <header className="ui-card__header">
          <div className="ui-card__heading">
            {title != null && <h3 className="ui-card__title">{title}</h3>}
            {subtitle != null && <div className="ui-card__subtitle">{subtitle}</div>}
          </div>
          {actions != null && <div className="ui-card__actions">{actions}</div>}
        </header>
      )}
      <div className={cx('ui-card__body', `ui-card__body--${padding}`)}>{children}</div>
    </section>
  );
}
